// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2KTX3","subheader":"ReorderModal_subheader__8oZ8O","listWrap":"ReorderModal_listWrap__3JYoF"};